import { useQuery } from '@tanstack/react-query'

import { apiRequest } from '@/shared/api/client'

import type { FanGrowthBucket, FanGrowthPeriod } from '../lib/athleteProfile'
import {
  ANALYTICS_AUDIENCE_KEY,
  ANALYTICS_FAN_GROWTH_KEY,
  type AnalyticsAudience,
  normaliseAudience
} from '../lib/clubAnalytics'
import { fetchFanGrowthAt } from './useAthleteProfile'

// The owner's Analytics tab — GET /v2/clubs/me/analytics/* (BAT-1102).

const STALE = 60_000

export async function fetchAnalyticsAudience(): Promise<AnalyticsAudience> {
  const raw = await apiRequest<unknown>({
    path: '/api/v2/clubs/me/analytics/audience',
    method: 'GET',
    format: 'json'
  })
  return normaliseAudience(raw)
}

export function useAnalyticsAudience() {
  return useQuery({
    queryKey: [ANALYTICS_AUDIENCE_KEY],
    queryFn: fetchAnalyticsAudience,
    staleTime: STALE
  })
}

/** The owner's own fan growth: works while the profile is not public yet. */
export function useAnalyticsFanGrowth(period: FanGrowthPeriod) {
  return useQuery<FanGrowthBucket[]>({
    queryKey: [ANALYTICS_FAN_GROWTH_KEY, period],
    queryFn: () =>
      fetchFanGrowthAt('/api/v2/clubs/me/analytics/fan-growth', period),
    staleTime: STALE
  })
}
